import { IApplicationState } from '../../types/redux';
import { EQueryStringActionType, TQueryStringActions } from '../../actions/queryString';

export function queryStringReducer(
  state: IApplicationState['queryString'] = '',
  action: TQueryStringActions,
): IApplicationState['queryString'] {
  switch (action.type) {
    case EQueryStringActionType.SetQueryString:
      return action.payload;
    default:
      return state;
  }
}
